import { getLogStatus } from '@/helpers/LogHelper';

export const handleLogsOnPriorityRequest = (
  channel: string,
  place = 'home_1',
) => {
  if (getLogStatus()) {
    // eslint-disable-next-line no-console
    console.table({
      type: 'get',
      request: `/recommendation/priority?place=${place}&channel=${channel}`,
    });
    // eslint-disable-next-line no-console
    console.log('\n');
  }
};

export const handleLogsOnDataRequest = (
  id: string,
  place: string | undefined,
) => {
  if (getLogStatus()) {
    // eslint-disable-next-line no-console
    console.table({
      type: 'get',
      request: `/recommendation?place=${place}&id=${id}`,
    });
    // eslint-disable-next-line no-console
    console.log('\n');
  }
};

export const handleLogsOnDetailsRequest = (url: string) => {
  if (getLogStatus()) {
    // eslint-disable-next-line no-console
    console.table({
      type: 'get',
      request: url,
    });
    // eslint-disable-next-line no-console
    console.log('\n');
  }
};
